import { useState } from "react"
import { useGetTasksQuery } from "../tasks/tasksApiSlice"
import TaskCharts from "./TaskCharts"
import { TaskCheckbox } from "../../components/TaskCheckbox"
import { useGetFinalQuestionsQuery } from "../questionSets/questionSetsApiSlice"
import { QuestionCheckbox } from "../../components/QuestionCheckbox"
import QuestionCharts from "./QuestionCharts"

const TaskChartsFilter = () => {
  const [showNames, setShowNames] = useState(false)
  const [selectedTasks, setSelectedTasks] = useState([])
  const [selectedQuestions, setSelectedQuestions] = useState([])
  const { data: tasks = [], isSuccess, isLoading }  = useGetTasksQuery("tasks") 
  const { data: finalQuestions, isSuccess:finalIsSuccess, isLoading : finalIsLoading } = useGetFinalQuestionsQuery({questionSetId:"0"})


  if (isLoading || finalIsLoading) return <div>טוען...</div>
  if (!isSuccess || ! finalIsSuccess) return <div>אירעה שגיאה בטעינת המשימות</div>


  return (
    <>
    <h1>בחר משימות / שאלונים להצגת גרפים</h1>
<div className=" mb-5">
  <TaskCheckbox tasks={tasks}    selectedTasks={selectedTasks} setSelectedTasks={setSelectedTasks} label="משימות" />
    <QuestionCheckbox questions={finalQuestions} selectedQuestions={selectedQuestions} setSelectedQuestions={setSelectedQuestions} label="שאלונים" />
</div>
    <input type="checkbox" defaultChecked={showNames} checked={showNames} onChange={()=>setShowNames(!showNames)} /> הצג שמות משתמשים
    
      {(selectedTasks.length >0) &&  <TaskCharts tasks={selectedTasks} showNames={showNames} /> }
      {(selectedQuestions.length >0) &&  <QuestionCharts questions={selectedQuestions} showNames={showNames} /> }
    </>
   

  )
}

export default TaskChartsFilter